import { useEffect } from 'react';
import type { ScreenType } from '@/features/deposit-bank-transfer';
import { useModalStore } from '@/shared/lib';

export function useModalScreen(screen: ScreenType, restoreOnUnmount = false) {
  const { getState, setState } = useModalStore();

  useEffect(() => {
    let prevScreen: ScreenType | undefined;

    try {
      if (typeof getState === 'function') {
        prevScreen = getState('screen') as ScreenType | undefined;
      }

      if (prevScreen !== screen && typeof setState === 'function') {
        setState('screen', screen);
      }
    } catch (e) {
      console.error('Error in useModalScreen:', e);
    }

    return () => {
      if (!restoreOnUnmount) return;
      try {
        if (typeof prevScreen !== 'undefined') {
          setState?.('screen', prevScreen);
        }
      } catch (e) {
        console.error('Error:', e);
      }
    };
  }, [getState, setState, screen, restoreOnUnmount]);
}
